import { useTrackingOccurence } from './use-tracking-occurrence';
export function useTimelineOccurrence() {
  var trackingOccurrence = useTrackingOccurence();
  return trackingOccurrence;
}